import { useTranslation } from 'react-i18next'
import { useState } from 'react'

import { Loader } from '@percent/admin-dashboard/common/components'
import styles from './Documents.module.scss'
import { DocumentsProps } from './Documents.types'
import { DocumentsGallery, Heading } from '@percent/lemonade'
import { ValidationDocument, ValidationSubmissionDocument } from '@percent/admin-dashboard/api/types'
import { LLMReasoning } from '@percent/admin-dashboard/app/agentVerification/agentVerificationDetails/components/agentVerificationDocuments/llmReasoning/LLMReasoning'

export function Documents({
  isLoading,
  documents,
  withPreview = false,
  children,
  showLLMReasoning = false
}: DocumentsProps) {
  const { t } = useTranslation()

  const hasDocuments = Array.isArray(documents) && documents?.length > 0

  const [selectedDocument, setSelectedDocument] = useState<ValidationSubmissionDocument | ValidationDocument | null>(
    documents?.[0] ?? null
  )

  const onSelectedFileChange = (fileUrl: string) => {
    if (fileUrl !== selectedDocument?.url) {
      setSelectedDocument(documents?.find(d => d.url === fileUrl) ?? null)
    }
  }

  return (
    <div className={styles.container} data-testid="documents">
      <div className={styles.title}>
        <Heading level="h6">{t('typography.documents')}</Heading>
      </div>

      {showLLMReasoning && <LLMReasoning document={selectedDocument as ValidationSubmissionDocument} />}
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {children}
          <p className={styles.subTitle}>
            {!hasDocuments && <>{t('typography.noDocumentsOrganisation')}</>}
            {!withPreview && hasDocuments && (
              <>
                {t('typography.organisationAttached')} {documents?.length} {t('typography.document')}
                {documents?.length !== 1 ? 's ' : ' '}
                {t('typography.forReview')}
              </>
            )}
          </p>
          {hasDocuments && (
            <DocumentsGallery
              files={documents}
              withPreview={withPreview}
              previewUrl="/document-preview"
              onSelectedFileChange={onSelectedFileChange}
            />
          )}
        </>
      )}
    </div>
  )
}
